export default __webpack_public_path__ + "static/media/LaserCuttingImg.19e09dd6.jpg";